import { Droppable } from "@hello-pangea/dnd";
import { isEmpty } from "ramda";

import NoResults from "./NoResults";
import Section from "./Section";

import { DROPPABLE_TYPES, ELEMENTS_LIST_DROPPABLE_ID } from "../../constants";

const SectionsContainer = ({
  isDragElementsDisabled,
  filteredSections,
  isAddingNewElement,
  onSelect,
  setVisiblePanel,
}) => {
  if (isEmpty(filteredSections)) {
    return <NoResults />;
  }

  if (isDragElementsDisabled) {
    return (
      <>
        {filteredSections.map(section => (
          <Section
            {...{
              isAddingNewElement,
              isDragElementsDisabled,
              onSelect,
              setVisiblePanel,
              ...section,
            }}
            key={section.key}
          />
        ))}
      </>
    );
  }

  return (
    <Droppable
      droppableId={ELEMENTS_LIST_DROPPABLE_ID}
      type={DROPPABLE_TYPES.ELEMENT}
    >
      {(provided, snapshot) => (
        <div ref={provided.innerRef}>
          {filteredSections.map(section => (
            <Section
              {...{
                isAddingNewElement,
                isDragElementsDisabled,
                onSelect,
                setVisiblePanel,
                ...section,
              }}
              isDraggingOver={snapshot.isDraggingOver}
              key={section.key}
            />
          ))}
        </div>
      )}
    </Droppable>
  );
};

export default SectionsContainer;
